import { React, useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import {
  RightLayoutContainer,
  PageTitleComp,
  TableLayoutData,
} from "../../styledElements";
import { Button, PageHeader, Table, Tooltip } from "antd";
import { Styled } from "../../pageStyled";
import Iconmoon from "../../../Components/IconsFiles/icon";
import SearchContainer from "../../../Components/SearchBarHeader/searchBar";
import {
  getJumboReels,
  searchJumboReels,
  getFilteredJumboReels,
  getExportDataForJumboReel,
  getExportDataForFilteredJumboReel,
} from "../../../Services/productionPlanningServices";
import moment from "moment";
import TableShimmer from "../../../Components/TableShimmer/tableShimmer";
import emptyState_Search from "../../../Assets/Images/emptyState_Search.svg";
import emptyState_NoData from "../../../Assets/Images/emptyState_NoData.svg";
import emptyState_ConnectionAPIError from "../../../Assets/Images/emptyState_ConnectionAPIError.svg";
import EmptyState from "../../../Components/EmptyState/emptyState";
import { lengthUnit, weightUnit } from "../../../Utils/Constant/MeasurementUnitList";
const capitalize = (item) => item.charAt(0).toUpperCase() + item.slice(1);
const JumboReelsData = (props) => {
  const [jumBoReels, setJumboReels] = useState([]);
  const [existingIds, setExistingIds] = useState([]);
  const [totalRecords, setTotalRecords] = useState();
  const [tableParams, setTableParams] = useState({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10,
  });
  const paginationRef = useRef({
    sort_by: "created_at",
    sort_type: "descending",
    page: 1,
    size: 10
  });
  const [currentPage, setCurrentPage] = useState(1);
  const [clearSearch, setClearSearch] = useState(false);
  const [searchValue, setSearchValue] = useState("");
  const [appliedFilters, setAppliedFilters] = useState([]);
  const [filterTags, setFilterTags] = useState([]);
  const [exportRecords, setExportRecords] = useState([]);
  const [userDetails, setUserDetails] = useState(
    JSON.parse(localStorage.getItem("user-details"))
  );
  const [loading, setLoading] = useState(true);
  const [emptyStateLabel, setEmptyStateLabel] = useState();
  const [emptyStatePropsData, setEmptyStatePropsData] = useState();
  const [rendering, setRendering] = useState(false);
  const [serachKey, setSearchKey] = useState(false);
  const columnsHead = useRef([
    {
      title: "JUMBO ROLL NO",
      dataIndex: "number",
      width: "35%",
      sorter: {
        compare: (a, b) => a.number - b.number,
      },
      fixed: "left",
      align: "left",
      render: (text, record) => (
        <div className="actionBtn jumbo-roll-column">
          <Button
            style={{ background: "transparent" }}
            className="textTypeBtn textBtnIcon"
            onClick={() => viewroute(record)}
          >
            {`#${record.number}`}
          </Button>
        </div>
      ),
    },
    {
      title: "MACHINE CODE",
      dataIndex: "machine",
      width: "14%",
      sorter: {
        compare: (a, b) => a.machine - b.machine,
      },
      fixed: "left",
      align: "left",
    },
    {
      title: "CREATED DATE",
      dataIndex: "created_at",
      width: "14%",
      sorter: {
        compare: (a, b) => new Date(a.created_at) - new Date(b.created_at),
      },
      //sortOrder: "descend",
    },
    {
      title: "WIDTH",
      dataIndex: "width",
      width: "10%",
      render: (text, record) => `${text} ${" "} ${record.units ? lengthUnit[record.units.width]?.displayName?.toUpperCase() : "CM"}`,
    },
    {
      title: "PROD.DATE",
      dataIndex: "production_date",
      width: "13%",
    },
    {
      title: "SHIFT",
      dataIndex: "shift",
      width: "8%",
      align: "center",
      render: (text) => (text ? text : "-"),
    },
    {
      title: "PRODUCT CODE",
      dataIndex: "product_code",
      width: "10.5%",
      align: "center",
    },
    {
      title: (
        <div>
          Product Spec
          <Styled style={{ display: "inline-flex" }}>
            <Tooltip
              placement="bottomRight"
              title={
                "The product specification is in the format of Grade/GSM/BF/Quality/Moisture"
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              <span className="infoIcon"></span>
            </Tooltip>
          </Styled>
        </div>
      ),
      dataIndex: "product_spec",
      width: "20%",
    },
    {
      title: "WEIGHT",
      dataIndex: "weight",
      width: "13%",
      align: "center",
      render: (text, record) => `${text} ${" "} ${capitalize(record.units ? weightUnit[record.units.weight]?.displayName : "T")}`,
    },
    {
      title: "% UTILIZED",
      dataIndex: "weight_utilized",
      width: "10%",
      align: "center",
    },
    {
      title: "STATUS",
      dataIndex: "status",
      width: "16%",
      render: (text, record) => (
        <div className="statusVal" dataval={record.status}>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={
                record.status === "Open"
                  ? "This jumbo roll is available for mapping parent reels in finishing"
                  : record.status === "Closed"
                  ? "This jumbo roll is not available for mapping any other parent reels in finishing"
                  : null
              }
              className="edit-tooltip"
              getPopupContainer={(triggerNode) => triggerNode}
            >
              {" "}
              {record.status}
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
    {
      title: "Actions",
      dataIndex: "action",
      width: "11%",
      render: (text, record) => (
        <div className="actionBtn">
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"Edit jumbo roll"}
              className="edit-tooltip"
            >
              <Button
                onClick={() => editroute(record)}
                disabled={
                  !userDetails.roles.production.jumbo_reels.edit ||
                  record.weightUtilized !== 0
                }
              >
                <Iconmoon icon="edit" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
          <Styled>
            <Tooltip
              placement="bottomRight"
              title={"View jumbo roll"}
              className="edit-tooltip"
            >
              <Button
                onClick={() => viewroute(record)}
                disabled={!userDetails.roles.production.jumbo_reels.view}
              >
                <Iconmoon icon="file-view" size={16} color="#A19F9D" />
              </Button>
            </Tooltip>
          </Styled>
        </div>
      ),
      align: "center",
    },
  ]);

  function capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  useEffect(() => {
  setLoading(true);
   if(rendering && !appliedFilters.length && searchValue == ""){
    fetchJumboReels(paginationRef.current);
    setRendering(false);
   }else if (!appliedFilters.length && searchValue == "")
      fetchJumboReels(paginationRef.current);
  }, [tableParams, rendering]);

  useEffect(() => {
    setLoading(true);
    if (appliedFilters.length) {
      fetchFilteredJumboReels();
    } else if (searchValue !== "") {
      setClearSearch(false);
      searchJumboReels(searchValue, paginationRef.current)
        .then((response) => {
          setLoading(false);
          const formattedRecords = response.jumbo_reels?.map((item) => {
            return {
              id: item.id,
              machine: item.machine,
              created_at: moment(item.created_at).format("DD-MMM-YYYY"),
              width: item.width,
              production_date: moment(item.production_date).format(
                "DD-MMM-YYYY"
              ),
              shift: item.shift,
              product_code: item.product,
              product_spec: item.product_spec,
              weight: item.weight + item.weight_utilized,
              weight_utilized: `${(
                (item.weight_utilized / (item.weight + item.weight_utilized)) *
                100
              ).toFixed(2)} %`,
              status: capitalizeFirstLetter(item.status),
              action: item.action,
              number: item.number,
              unit: item.units
            };
          });
          setJumboReels(formattedRecords);
          setTotalRecords(response.total_jumbo_reels);
        })
        .catch((error) => {
          console.log("Error in searching products:", error);
        });
    } else {
      fetchJumboReels(paginationRef.current);
    }
  }, [appliedFilters, tableParams]);

  useEffect(() => {
    let propsData = {};
    if(emptyStateLabel === "noData"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records in this list";
      propsData["subHeading"] = "There are no records to show in this list. Add your first record to view details here";
    } else if(emptyStateLabel === "search"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your search keyword. Try adjusting your search to find what you are looking for.";
    } else if(emptyStateLabel === "filter"){
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "No records found";
      propsData["subHeading"] = "There is no record matching your filter. Try changing your filter to find what you are looking for.";
    } else {
      propsData["label"] = emptyStateLabel;
      propsData["heading"] = "Something went wrong";
      propsData["subHeading"] = "Check your internet connection or try reloading the page.";
    }
    setEmptyStatePropsData(propsData);
  },[emptyStateLabel]);

  const fetchFilteredJumboReels = () => {
   
    getFilteredJumboReels(paginationRef.current, appliedFilters)
      .then((response) => {
        setLoading(false);
        setEmptyStateLabel("filter");
        const filteredList = response.data.jumbo_reels.map((item) => {
          return {
            id: item.id,
            machine: item.machine,
            created_at: moment(item.created_at).format("DD-MMM-YYYY"),
            width: item.width,
            production_date: moment(item.production_date).format("DD-MMM-YYYY"),
            shift: item.shift,
            product_code: item.product,
            product_spec: item.product_spec,
            weight: item.weight + item.weight_utilized,
            weight_utilized: `${(
              (item.weight_utilized / (item.weight + item.weight_utilized)) *
              100
            ).toFixed(2)} %`,
            status: capitalizeFirstLetter(item.status),
            action: item.action,
            number: item.number,
            unit: item.units
          };
        });
        setJumboReels(filteredList);
        setTotalRecords(response.data.total_jumbo_reels);
      })
      .catch((error) => console.log(error),
      setEmptyStateLabel("connectionAPIError"));
  };

  const fetchJumboReels = async (params) => {
    getJumboReels(params)
      .then((resp) => {
        if(!resp.data.data.jumbo_reels.length){
          setEmptyStateLabel("noData");
        }
        const list = resp.data.data.jumbo_reels?.map((item) => {
          return {
            id: item.id,
            machine: item.machine,
            created_at: moment(item.created_at).format("DD-MMM-YYYY"),
            width: item.width,
            production_date: moment(item.production_date).format("DD-MMM-YYYY"),
            shift: item.shift,
            product_code: item.product,
            product_spec: item.product_spec,
            weight: item.weight + item.weight_utilized,
            weight_utilized: `${(
              (item.weight_utilized / (item.weight + item.weight_utilized)) *
              100
            ).toFixed(2)} %`,
            weightUtilized: item.weight_utilized,
            status: capitalizeFirstLetter(item.status),
            action: item.action,
            number: item.number,
            units: item.units
          };
        });
        setJumboReels(list);
        setTotalRecords(resp.data.data.total_jumbo_reels);
        const numbers = list.map((item) => {
          return item.number;
        });
        setExistingIds(numbers);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
        console.log("Jumbo reels fetch error", err);
        setEmptyStateLabel("connectionAPIError");
      });
  };

  function onChange(pagination, filters, sorter, extra) {
    setJumboReels([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      if(item.dataIndex !== sorter?.field){
        item["sortOrder"] = null;
      } 
      if (item.dataIndex == sorter?.field) {
        item["sortOrder"] = sorter ? sorter.order : "";
      }
    });
    const tempSort = sorter.order === "ascend" ? "ascending" : "descending";
    if (
      sorter.field &&
      (paginationRef.current.sort_type !== tempSort ||
        paginationRef.current.sort_by !== sorter.field)
    ) {
      setClearSearch(true);
      setCurrentPage(1);
      setTableParams({
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: 1,
        size: pagination.pageSize,
        sort_by: sorter.field,
        sort_type: tempSort,
      };
    } else {
      setClearSearch(true);
      setCurrentPage(pagination.current);
      setTableParams({
        page: pagination.current,
        size: pagination.pageSize,
        // sort_by: sorter.field || tableParams.sort_by,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      });
      paginationRef.current = {
        page: pagination.current,
        size: pagination.pageSize,
        sort_by: sorter.order ? sorter.field : "created_at",
        sort_type: tempSort,
      };
    }
  }

  const refresh  = () => {
    setLoading(true);
    setJumboReels();
    setSearchValue("");
    setClearSearch(true);
    setRendering(true);
  }

  const searchJumbo = async (value = "") => {
    setJumboReels([]);
    setLoading(true);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    setSearchValue(value);
    if (value === "" || value === null) {
      setAppliedFilters([]);
      setFilterTags([]);
      fetchJumboReels(paginationRef.current);
    } else {
      setSearchValue(value);
      setClearSearch(false);
      searchJumboReels(value, paginationRef.current)
        .then((response) => {
          setLoading(false);
          setEmptyStateLabel("search");
          const formattedRecords = response.jumbo_reels?.map((item) => {
            return {
              id: item.id,
              machine: item.machine,
              created_at: moment(item.created_at).format("DD-MMM-YYYY"),
              width: item.width,
              production_date: moment(item.production_date).format(
                "DD-MMM-YYYY"
              ),
              shift: item.shift,
              product_code: item.product,
              product_spec: item.product_spec,
              weight: item.weight + item.weight_utilized,
              weight_utilized: `${(
                (item.weight_utilized / (item.weight + item.weight_utilized)) *
                100
              ).toFixed(2)} %`,
              status: capitalizeFirstLetter(item.status),
              action: item.action,
              number: item.number,
              unit: item.units
            };
          });
          setJumboReels(formattedRecords);
          setTotalRecords(response.total_jumbo_reels);
        })
        .catch((error) => {
          console.log("Error in searching products:", error);
          setEmptyStateLabel("connectionAPIError");
        });
    }
  };

  const history = useNavigate();
  const routeChange = () => {
    history("./add-new-jumbo-reel", { state: { existingIds } });
  };
  const editroute = (record) => {
    history("./edit-jumbo-reel", { state: { id: record.number } });
  };
  const viewroute = (record) => {
    history("./view-jumbo-reel", { state: { id: record.number } });
  };

  useEffect(() => {
    if (exportRecords.length) {
      const currentDate = new Date();
      const today =
        currentDate.getDate() +
        "/" +
        currentDate.toLocaleString("default", { month: "long" }) +
        "/" +
        currentDate.getFullYear();
      let fileName = "Jumbo_roll_records_Kaiznn_" + today;
      history("../jumbo-reel-records/export", {
        state: {
          rootPage: "../jumbo-reel-records",
          jumboRecords: exportRecords,
          pageKey: "Jumbo Reels Records",
          searchKey: serachKey,
          fileName: fileName,
        },
      });
    }
  }, [exportRecords]);

  const exportHandler = () => {
    if (appliedFilters.length) {
      getExportDataForFilteredJumboReel(appliedFilters).then((response) => {
        const list = response.data?.map((item) => {
          return {
            created_date: item.created_date
            ? moment(item.created_date).format("DD-MMM-YYYY")
            : "",
            machine: item.machine? item.machine.code : "",
            number: item.number,
            code: item.product ? item.product.code : "",
            name: item.product? item.product.name : "",
            gsm: item.product? item.product.gsm : "",
            grade: item.product? item.product.grade : "",
            bf: item.product?  item.product.burst_factor : "",
            quality: item.product?  item.product.quality : "",
            product_spec: item.product? item.product.product_spec : "",
            production_date: item.production_date,
            shift: item.shift,
            status: item.status,
            weight: (item.weight || item.utilized) ? (item.weight + item.utilized)?.toFixed(3) : "",
            utilized: `${(
              (item.utilized / (item.weight + item.utilized)) *
              100
            ).toFixed(2)}`,
            width: item.width,
            units: item.units
          };
        });
        setExportRecords(list);
      });
    } else if (searchValue) {
      setSearchKey(true);
      let params = {
        sort_by: "created_at",
        sort_type: "descending",
      };
      searchJumboReels(searchValue, params).then((response) => {
        const formattedRecords = response?.map((item) => {
          return {
            number: item.id,
            machine: item.machine? item.machine : "",
            created_date: item.created_at
              ? moment(item.created_at).format("DD-MMM-YYYY")
              : "",
            width: item.width,
            code: item.product? item.product : "",
            name: item.product_info? item.product_info.name : "",
            grade: item.product_info? item.product_info.grade : "",
            gsm: item.product_info? item.product_info.gsm : "",
            bf: item.product_info? item.product_info.burst_factor : "",
            quality: item.product_info ? item.product_info.quality : "",
            product_spec: item.product_info ? item.product_spec : "",
            production_date: item.production_date
              ? moment(item.production_date).format("DD-MMM-YYYY")
              : "",
            shift: item.shift,
            weight: (item.weight || item.weight_utilized) ? (item.weight + item.weight_utilized)?.toFixed(3) : "",
            utilized: `${(
              (item.weight_utilized / (item.weight + item.weight_utilized)) *
              100
            ).toFixed(2)} %`,
            status: item.status,
            number: item.number,
            units: item.units
          };
        });
        setExportRecords(formattedRecords);
      });
    } else {
      getExportDataForJumboReel().then((resp) => {
        const list = resp.data?.map((item) => {
          return {
            created_date: item.created_date,
            machine: item.machine? item.machine.code : "",
            number: item.number,
            code: item.product ? item.product.code : "",
            name: item.product? item.product.name : "",
            gsm: item.product? item.product.gsm : "",
            grade: item.product? item.product.grade : "",
            bf: item.product?  item.product.burst_factor : "",
            quality: item.product?  item.product.quality : "",
            product_spec: item.product? item.product.product_spec : "",
            production_date: item.production_date,
            shift: item.shift,
            status: item.status,
            weight: (item.weight || item.utilized) ? (item.weight + item.utilized)?.toFixed(3) : "",
            utilized: `${(
              (item.utilized / (item.weight + item.utilized)) *
              100
            ).toFixed(2)}`,
            width: item.width,
            units: item.units
          };
        });
        setExportRecords(list);
      });
    }
  };

  const applyfilter = (filter) => {
    setJumboReels([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    setCurrentPage(1);
    setTableParams((prevState) => ({
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }));
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
    let temp = appliedFilters;
    let alreadySetFilter = false;
    for (let i = 0; i < temp.length; i++) {
      if (temp[i].type === filter.type) {
        temp[i] = filter;
        alreadySetFilter = true;
      }
    }
    const tempVar = alreadySetFilter ? [...temp] : temp.concat(filter);
    setAppliedFilters(tempVar);
    setFilterTags(tempVar.map(formatFilters));
  };
  const formatFilters = (item) => {
    switch (item.type) {
      case "gsm":
        let gsmOperand = "";
        let gsmValue = "";
        if (item.operator === "in_range") {
          gsmOperand = "between";
          gsmValue = `${item.min_gsm} and ${item.max_gsm}`;
        } else if (item.operator === "equal_to") {
          gsmOperand = "equals";
          gsmValue = `${item.gsm}`;
        } else if (item.operator === "less_than") {
          gsmOperand = "less than";
          gsmValue = `${item.gsm}`;
        } else {
          gsmOperand = "greater than";
          gsmValue = `${item.gsm}`;
        }
        return {
          type: item.type,
          formattedType: "GSM",
          operand: gsmOperand,
          value: gsmValue,
        };
      case "grade_quality":
        const gradeValue =
          item.grades.length > 1
            ? `${item.grades[0].grade}(${item.grades[0].qualities.join()}) or ${
                item.grades.length - 1
              } others`
            : `${item.grades[0].grade}` + (item.grades[0].qualities?.length ? `"(${item.grades[0].qualities.join()})"` : ``);
        return {
          type: item.type,
          formattedType: "Grade",
          operand: "-",
          value: gradeValue,
        };
      case "burst_factor":
        let burstOperand = "";
        let burstValue = "";
        if (item.operator === "in_range") {
          burstOperand = "between";
          burstValue = `${item.min_burst_factor} and ${item.max_burst_factor}`;
        } else if (item.operator === "equal_to") {
          burstOperand = "equals";
          burstValue = `${item.burst_factor}`;
        } else if (item.operator === "less_than") {
          burstOperand = "less than";
          burstValue = `${item.burst_factor}`;
        } else {
          burstOperand = "greater than";
          burstValue = `${item.burst_factor}`;
        }
        return {
          type: item.type,
          formattedType: "Burst Factor",
          operand: burstOperand,
          value: burstValue,
        };
      case "created_date":
        let dateOperand = "";
        let dateValue = "";
        if (item.start_date === item.end_date) {
          dateOperand = "-";
          dateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          dateOperand = "between";
          dateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Created date",
          operand: dateOperand,
          value: dateValue,
        };
      case "production_date":
        let prodDateOperand = "";
        let prodDateValue = "";
        if (item.start_date === item.end_date) {
          prodDateOperand = "-";
          prodDateValue = moment(item.start_date).format("DD MMMM YY");
        } else {
          prodDateOperand = "between";
          prodDateValue = `${moment(item.start_date).format(
            "DD MMMM YY"
          )} - ${moment(item.end_date).format("DD MMMM YY")}`;
        }
        return {
          type: item.type,
          formattedType: "Production date",
          operand: prodDateOperand,
          value: prodDateValue,
        };
      case "width":
        let widthOperand = "";
        let widthValue = "";
        if (item.operator === "in_range") {
          widthOperand = "between";
          widthValue = `${item.min_width} and ${item.max_width}`;
        } else if (item.operator === "equal_to") {
          widthOperand = "equals";
          widthValue = `${item.width}`;
        } else if (item.operator === "less_than") {
          widthOperand = "less than";
          widthValue = `${item.width}`;
        } else {
          widthOperand = "greater than";
          widthValue = `${item.width}`;
        }
        return {
          type: item.type,
          formattedType: "Width",
          operand: widthOperand,
          value: widthValue,
        };
      case "utilization":
        let utilizationOperand = "";
        let utilizationValue = "";
        if (item.operator === "in_range") {
          utilizationOperand = "between";
          utilizationValue = `${item.min_utilization} and ${item.max_utilization}`;
        } else if (item.operator === "equal_to") {
          utilizationOperand = "equals";
          utilizationValue = `${item.utilization}`;
        } else if (item.operator === "less_than") {
          utilizationOperand = "less than";
          utilizationValue = `${item.utilization}`;
        } else {
          utilizationOperand = "greater than";
          utilizationValue = `${item.utilization}`;
        }
        return {
          type: item.type,
          formattedType: "Utilization",
          operand: utilizationOperand,
          value: utilizationValue,
        };
      case "shift":
        const value =
          item.shifts.length > 1
            ? `${item.shifts[0]} or ${item.shifts[1]}`
            : `${item.shifts[0]}`;
        return { type: item.type, formattedType: "Shift", operand: "-", value };
      case "status":
        const statusValue =
          item.status.length > 1
            ? `${item.status[0]} or ${item.status[1]}`
            : `${item.status[0]}`;
        return {
          type: item.type,
          formattedType: "Status",
          operand: "-",
          value: statusValue,
        };
      case "machine":
        const machineValue =
          item.machines.length > 1
            ? `${item.machines[0]} or ${item.machines.length - 1} others`
            : `${item.machines[0]}`;
        return {
          type: item.type,
          formattedType: "Machine",
          operand: "equals",
          value: machineValue,
        };
    }
  };
  const removeFilter = (filter) => {
    setJumboReels([]);
    columnsHead.current?.map((item) => {
      item["sortOrder"] = null;
  });
    const filterList = appliedFilters.filter((item) => {
      return item.type !== filter.type;
    });
    const formattedFilterList = filterTags.filter((item) => {
      return item.type !== filter.type;
    });
    setFilterTags(formattedFilterList);
    setAppliedFilters(filterList);
    setRendering(true);
    setSearchValue("");
    setClearSearch(true);
    setLoading(true);
    setCurrentPage(1);
    setTableParams((prevState) => ({
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }));
    paginationRef.current = {
      sort_by: "created_at",
      sort_type: "descending",
      page: 1,
      size: 10
    }
  };
  return (
    <RightLayoutContainer>
      <PageTitleComp>
        <PageHeader
          ghost={false}
          title="Jumbo Roll Records"
          extra={[
            <Button
              key="2"
              className="themeBtn"
              onClick={routeChange}
              disabled={!userDetails.roles.production.jumbo_reels.edit}
            >
              <Iconmoon icon="addcircle" size={14} color="#ffffff" />
              Add a new Jumbo Roll
            </Button>,
          ]}
        ></PageHeader>
      </PageTitleComp>
      <TableLayoutData>
        <div className="tableDataFormat">
          <SearchContainer
            placeholder={"Search jumbo number"}
            exportRole={jumBoReels?.length ? true : false}
            exportTrigger={exportHandler}
            fetchOrder={searchJumbo}
            clearSearch={clearSearch}
            setClearSearch={setClearSearch}
            searchedValue={searchValue}
            filterOptions={[
              {
                key: 0,
                label: "Filter by GSM",
                value: "gsm",
                type: "inputSelect",
              },
              {
                key: 1,
                label: "Filter by Grade/Quality",
                value: "grade_quality",
                type: "grade",
              },
              {
                key: 2,
                label: "Filter by Burst Factor",
                value: "burst_factor",
                type: "inputSelect",
              },
              {
                key: 3,
                label: "Filter by Created date",
                value: "created_date",
                type: "date",
              },
              {
                key: 4,
                label: "Filter by Production date",
                value: "production_date",
                type: "date",
              },
              {
                key: 5,
                label: "Filter by Width",
                value: "width",
                type: "inputSelect",                
                unitType:"length"
              },
              {
                key: 6,
                label: "Filter by Utilization",
                value: "utilization",
                type: "inputSelect",
              },
              {
                key: 7,
                label: "Filter by Shift",
                value: "shift",
                type: "multiSelect",
              },
              {
                key: 8,
                label: "Filter by Status",
                value: "statusOpen",
                type: "multiSelect",
              },
              {
                key: 9,
                label: "Filter by Machine",
                value: "machine",
                type: "multiSelect",
              },
            ]}
            applyFilter={applyfilter}
          />
          {filterTags.map((filter) => (
            <span className="filter-tags">
              <Iconmoon icon="filter" size={13} color="#a8a8a8" />
              &nbsp;
              <span>{filter.formattedType}</span>
              &nbsp;
              <span>{filter.operand}</span>
              &nbsp;
              <span>{filter.value}</span>
              <span>
                {" "}
                <button
                  onClick={() => {
                    removeFilter(filter);
                  }}
                >
                  {" "}
                  <Iconmoon icon="wrong" size={15} color="#a8a8a8" />{" "}
                </button>
              </span>
            </span>
          ))}
          {loading ? (
                    <TableShimmer
                      header = {columnsHead.current}
                      scroll={ window.screen.width < 1500 && 1500 }
                    />
                  ) : jumBoReels?.length ? (
          <Table
            columns={columnsHead.current}
            dataSource={jumBoReels}
            scroll={{ x:  1510 }}
            onChange={onChange}
            pagination={{
              current: currentPage,
              total: totalRecords,
              showTitle: false,
              pageSize: paginationRef.current.size,
              showTotal: (total, range) =>
                `Showing ${range[0]}-${range[1]} of ${total} results`,
            }}
          />
          ) : (
            <EmptyState
              img= {emptyStateLabel === "noData" || emptyStateLabel === "filter" ? emptyState_NoData : 
              emptyStateLabel === "search" ? emptyState_Search : 
              emptyState_ConnectionAPIError}
              heading= {emptyStatePropsData.heading}
              subHeading= {emptyStatePropsData.subHeading}
              label={emptyStatePropsData.label}
              refresh={refresh}
              />
          )}
        </div>
      </TableLayoutData>
    </RightLayoutContainer>
  );
};

export default JumboReelsData;
